var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCheckedBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.794189,
    y: 1.00879,
    width: 17,
    height: 17,
    rx: 1.5,
    fill: "white",
    stroke: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3715 13.3538L3.46986 9.86595C3.35738 9.76533 3.29419 9.6289 3.29419 9.48665C3.29419 9.3444 3.35738 9.20797 3.46986 9.10735L4.31922 8.34875C4.43178 8.2482 4.58439 8.19171 4.74352 8.19171C4.90265 8.19171 5.05527 8.2482 5.16783 8.34875L7.79393 10.6963L13.4213 5.66583C13.5339 5.56527 13.6865 5.50879 13.8456 5.50879C14.0047 5.50879 14.1574 5.56527 14.2699 5.66583L15.1185 6.42442C15.231 6.52504 15.2942 6.66147 15.2942 6.80372C15.2942 6.94597 15.231 7.0824 15.1185 7.18302L8.21561 13.3538C8.10324 13.4531 7.95159 13.5088 7.79356 13.5088C7.63553 13.5088 7.48387 13.4531 7.3715 13.3538Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCheckedBox);
export default __webpack_public_path__ + "static/media/TickCheckedBox.a83a8b4f315a4c602335245c995c1072.svg";
export { ForwardRef as ReactComponent };